<template>
<div class='page-start'>
	<mdb-container class="pb-3" fluid>

        <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p1" @closeAlert="p1=false" dismiss>
            Success! Submitted Asset Data!
        </mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p2" @closeAlert="p2=false" dismiss>
            There was an error submitting Asset: {{ this.errorMsg }}. Please try again! Error Code P2
        </mdb-alert>
        <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p3" @closeAlert="p3=false" dismiss>
            Success! Set Asset as Removed!
        </mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p4" @closeAlert="p4=false" dismiss>
            There was an error removing the Asset. Please try again! Error Code P4
        </mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p5" @closeAlert="p5=false" dismiss>
            There was an error fetching asset data. Please try again! Error Code P5
        </mdb-alert>
        <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p6" @closeAlert="p6=false" dismiss>
            Successfully scanned QRCode!
        </mdb-alert>
        <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p7" @closeAlert="p7=false" dismiss>
            Successfully scanned QRCode! QRCode is unused, add it below!
        </mdb-alert>

        <mdb-card class="mb-3 d-flex">
        <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">Submit Asset Information</h3>
        <mdb-card-body>
            <form class="was-validated">
    
                <!-- For Desktop -->
                <div class="d-none d-md-block">
                  <mdb-row>
                      <mdb-col>
                          <mdb-date-picker-2 v-model="displayDateSubmit" label='Date Created' id="dateClosed" title='Date Created' disabled/>
                      </mdb-col>
                      <mdb-col>
                          <mdb-input type="text" maxlength="50" label="Asset Number" v-model="assetNumber" required 
                          invalid-feedback="Please Input Asset Number" valid-feedback="Looks Good!" :readOnly="isRemoved"/>
                      </mdb-col>
                      <mdb-col>
                            <mdb-select class="mb-3" v-model="assetOptions" @getValue="setAssetType" label="Asset Type" :disabled="isRemoved"/>
                            <div v-if="!assetType" class="text-danger small mt-1">
                                Please Select an Option
                            </div>
                            <div v-if="assetType" class="text-success small mt-1">
                                Looks Good!
                            </div>
                      </mdb-col>
                  </mdb-row>
                  <mdb-row>
                      <mdb-col>
                          <mdb-date-picker-2 v-model="displayDateModified" label='Date Modified' id="dateModified" title='Date Modified' disabled/>
                      </mdb-col>
                      <mdb-col>
                          <mdb-input label="Location" v-model="assetLocation" required invalid-feedback="Please Input Asset Location" 
                          valid-feedback="Looks Good!" :readOnly="isRemoved" maxlength="120"/>
                      </mdb-col>
                      <mdb-col>
                            <mdb-select id="userDropdown" class="mb-3" search :value="assignedTo ? [assignedTo] : []" :options="userOptions" @getValue="setAssignment" label="Assigned To" :disabled="isRemoved"/>
                            <div v-if="assetType == 'CUI' && !assignedTo" class="text-danger small mt-1">
                                Please Select an Option
                            </div>
                            <div v-else class="text-success small mt-1">
                                Looks Good!
                            </div>
                      </mdb-col>
                  </mdb-row>
                </div>
                <!-- -->
                <!-- For Mobile -->
                <div class="d-block d-md-none">
                    <mdb-row class="justify-content-center mb-4">
                        <!--<qrcode-stream ref="QRCodeCamera" class="pt-3" v-if="QRCamera" :camera="camera" @decode="onDecode" :paused="!scanning"></qrcode-stream>-->
                        <div id="qr-reader" style="width: 300px; margin: auto;"></div>
                        <mdb-btn v-if="!QRCamera" class='QuadrusButton d-block d-md-none' size="lg" v-on:click="enableCamera">Enable QR Code Scanner</mdb-btn>
                    </mdb-row>
                  <mdb-row>
                    <mdb-col>
                      <mdb-date-picker-2 v-model="displayDateSubmit" label='Date Created' id="dateClosed" title='Date Created' disabled/>
                    </mdb-col>
                  </mdb-row>
                  <mdb-row>
                    <mdb-col>
                        <mdb-date-picker-2 v-model="displayDateModified" label='Date Modified' id="dateModified" title='Date Modified' disabled/>
                    </mdb-col>
                  </mdb-row>
                  <mdb-row>
                    <mdb-col>
                        <mdb-input type="text" maxlength="50" label="Asset Number" v-model="assetNumber" required invalid-feedback="Please Input Asset Number" 
                        valid-feedback="Looks Good!" :readOnly="isRemoved"/>
                    </mdb-col>
                  </mdb-row>
                  <mdb-row>
                    <mdb-col>
                      <mdb-select class="mb-3" v-model="assetOptions" @getValue="setAssetType" label="Asset Type" :disabled="isRemoved"/>
                        <div v-if="!assetType" class="text-danger small mt-1">
                            Please Select an Option
                        </div>
                        <div v-if="assetType" class="text-success small mt-1">
                            Looks Good!
                        </div>
                    </mdb-col>
                  </mdb-row>
                  <mdb-row>
                    <mdb-col>
                        <mdb-select id="userDropdown" class="mb-3" :disabled="isRemoved" search :value="assignedTo ? [assignedTo] : []" :options="userOptions" 
                        @getValue="setAssignment" label="Assigned To"/>
                        <div v-if="assetType == 'CUI' && !assignedTo" class="text-danger small mt-1">
                            Please Select an Option
                        </div>
                        <div v-else class="text-success small mt-1">
                            Looks Good!
                        </div>
                    </mdb-col>
                  </mdb-row>
                  <mdb-row>
                        <mdb-col>
                          <mdb-input label="Location" v-model="assetLocation" required invalid-feedback="Please Input Asset Location" 
                          valid-feedback="Looks Good!" :readOnly="isRemoved" maxlength="120"/>
                      </mdb-col>
                  </mdb-row>
                </div>
                <!-- -->
                <mdb-row>
                    <mdb-col>
                        <mdb-input label="Item Name" v-model="assetItem" required invalid-feedback="Please Input Asset Name" 
                        valid-feedback="Looks Good!" :readOnly="isRemoved" maxlength="50" />
                    </mdb-col>
                </mdb-row>
                <mdb-row>
                    <mdb-col>
                        <mdb-input label="Item Description" v-model="assetDescription" required invalid-feedback="Please Input Asset Description" 
                        valid-feedback="Looks Good!" :readOnly="isRemoved" maxlength="120"/>
                    </mdb-col>
                </mdb-row>
                <mdb-row>
                    <mdb-col>
                        <mdb-input label="Serial Number" v-model="assetSerialNumber" required invalid-feedback="Please Input Asset Serial Number" 
                        valid-feedback="Looks Good!" :readOnly="isRemoved" maxlength="60"/>
                    </mdb-col>
                </mdb-row>
                <mdb-row v-if="isRemoved">
                    <mdb-col>
                        <mdb-input type="textarea" :rows="4" outline label="Reason for Removal" v-model="reasonForRemoval" readOnly maxlength="500"/>
                    </mdb-col>
                </mdb-row>

                <mdb-btn id="submitAddAsset" class='QuadrusButton' size="lg" :disabled="isRemoved" v-on:click="submitAsset">Submit</mdb-btn>
                <br>
                <mdb-btn id="clearAsset" color="danger" size="lg" v-on:click="clearAssetForm">Clear</mdb-btn>
            </form>
        </mdb-card-body>
        </mdb-card>

        
        <mdb-card class="mb-3 d-flex">
        <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">Quadrus Corporation Assets</h3>
        <mdb-card-body>
            <mdb-row>
                <mdb-col >
                    <h5 class="card-title font-weight-bold text-uppercase mt-2">Filter By Asset Type</h5>
                        <mdb-row>
                            <mdb-col>
                                <mdb-input class="mb-0 mt-2" type="checkbox" id="CUISort" v-model="CUISort" name="CUISort" label="Show CUI Assets" @click.native.prevent="handleToggle('CUI')"/>
                           
                                <mdb-input class="mb-0 mt-2" type="checkbox" id="facilitySort" v-model="facilitySort" name="facilitySort" label="Show Facility Management Assets" @click.native.prevent="handleToggle('facility')"/>

                                <mdb-input class="mb-0 mt-2" type="checkbox" id="itSort" v-model="itSort" name="itSort" label="Show IT Assets" @click.native.prevent="handleToggle('IT')"/>
                            </mdb-col>
                        </mdb-row>
                </mdb-col>
                <mdb-col >
                    <h5 class="card-title font-weight-bold text-uppercase mt-2">Filter By Asset Status</h5>
                    <mdb-row>
                        <mdb-col>
                            <mdb-input class="mb-0 mt-2" type="checkbox" id="showRemoved" name="showRemoved" v-model="showRemoved" label="Show Removed Assets"/>
                        </mdb-col>
                    </mdb-row> 
                </mdb-col>
            </mdb-row>
            
            <br><br>

            <mdb-btn class="QuadrusButton" v-on:click="viewReport = true">Generate Report</mdb-btn>
            <mdb-modal size="xl" centered :show="viewReport" @close="viewReport = false" style="z-index: 9999 !important;">
                <mdb-modal-header>
                <mdb-modal-title><p class="h2 grey-text">Generate Report</p></mdb-modal-title>
                </mdb-modal-header>
                <mdb-modal-body style="font-size: 0.9em;">
                    <mdb-row>
                        <mdb-col >
                            <h5 class="card-title font-weight-bold text-uppercase mt-2">Filter By Asset Type</h5>
                                <mdb-row>
                                    <mdb-col>
                                        <mdb-input class="mb-0 mt-2" type="checkbox" id="CUISort" v-model="CUISort" name="CUISort" label="Show CUI Assets" @click.native.prevent="handleToggle('CUI')"/>
                                
                                        <mdb-input class="mb-0 mt-2" type="checkbox" id="facilitySort" v-model="facilitySort" name="facilitySort" label="Show Facility Management Assets" @click.native.prevent="handleToggle('facility')"/>

                                        <mdb-input class="mb-0 mt-2" type="checkbox" id="itSort" v-model="itSort" name="itSort" label="Show IT Assets" @click.native.prevent="handleToggle('IT')"/>
                                    </mdb-col>
                                </mdb-row>
                        </mdb-col>
                        <mdb-col >
                            <h5 class="card-title font-weight-bold text-uppercase mt-2">Filter By Asset Status</h5>
                            <mdb-row>
                                <mdb-col>
                                    <mdb-input class="mb-0 mt-2" type="checkbox" id="showRemoved" name="showRemoved" v-model="showRemoved" label="Show Removed Assets"/>
                                </mdb-col>
                            </mdb-row> 
                        </mdb-col>
                    </mdb-row>
                </mdb-modal-body>

                <mdb-modal-footer class="d-flex justify-content-between">
                    <mdb-btn color="secondary" @click.native="viewReport = false">Close</mdb-btn>
                    <download-csv class="btn QuadrusButton" 
                        :data="this.assetData.rowData.map(({ id, displayDateModified, displayDateSubmit, ...rest }) => rest)" 
                        name="assetReport.csv">Generate Report</download-csv>
                </mdb-modal-footer>
            </mdb-modal>
           
                        
            <QDataTable ref="assetTable" id='assetTable' :rowData="this.assetData.rowData" :filterWords="this.assetData.filterWords" :headers="this.assetData.columns" 
            :btnName="'Manage'" :hasBtn="true" @use-method="manageAsset" :hasDelete="!showRemoved" @delete="deleteAsset" :deleteName="'Remove'" @deleteInfo="assetInfo"
            :class="{'hideTable': !isSetUp, 'fadeIn' : isSetUp}">
            
            <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="requiredRemove" @closeAlert="requiredRemove=false" dismiss>
                Failed to remove asset. Missing Required Fields.
            </mdb-alert>
            <p>This will remove the asset from the list. It will appear in the list of removed assets.</p>
            <form class="was-validated">
                <mdb-input outline type='textarea' :rows="4" maxlength="500" label="Reason for removal" v-model="reasonForRemoval" required/>
            </form>
            <p>Do you wish to continue?</p>
            </QDataTable>
            
            <div :class="{'hideSpinner': isSetUp}" class="p-4">
                <span class="spinner-border spinner-border-xl" id="loadSpinner" role="status" aria-hidden="true"></span>
            </div>
        </mdb-card-body>
        </mdb-card>

    </mdb-container>
</div>
</template>

<style>
#qr-reader video {
  width: 100%;
  height: auto;
  object-fit: contain;
  filter: contrast(1.4) brightness(1.1) sharpness(1.2);
}
</style>
<script>
import Vue from 'vue'
import { mdbInput, mdbCard, mdbBtn, mdbCol, mdbRow, mdbDatePicker2, mdbCardBody, mdbContainer, mdbAlert, mdbSelect, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter } from 'mdbvue';
//import { QrcodeStream } from 'vue-qrcode-reader'
import QDataTable from '@/components/QDataTable.vue';
import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
import JsonCSV from 'vue-json-csv';
import { Html5Qrcode } from "html5-qrcode";
import { formatDate } from '@/assets/js/formatDate.js';
import * as sanitizeInput from '@/assets/js/sanitizeInput.js';

Vue.component('downloadCsv', JsonCSV)

export default {
	name: 'ASSETS',
	components: {
    mdbInput,
    mdbCard,
    mdbBtn,
    mdbCol,
    mdbRow,
    mdbDatePicker2,
    mdbCardBody,
    mdbContainer,
    mdbAlert,
    QDataTable,
    //QrcodeStream,
    mdbSelect,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter
    },
    
    data() {
        return {
            isSetUp: false,
            search: '',
            errorMsg: '',

            viewReport: false,
            CUISort: true,
            facilitySort: true,
            itSort: true,
            showRemoved: false,

            QRCamera: false,
            camera: 'rear',
            scanning: false,
            scanner: null,
            assetNumberQR: { assetNumber: '' },

            p1: false,
            p2: false,
            p3: false,
            p4: false,
            p5: false,
            p6: false,
            p7: false,
            requiredRemove: false,

            editingAsset: false,

            displayDateSubmit: formatDate(new Date().toISOString()),
            displayDateModified: formatDate(new Date().toISOString()),
            dateSubmit: new Date().toISOString(),
            dateModified: '',
            assetNumber: '',
            assetLocation: '',
            assetItem: '',
            assetDescription: '',
            assetSerialNumber: '',
            assetType: '',
            assignedTo: '',
            isRemoved: false,
            reasonForRemoval: '',
            
            manageAssetID: '',
            selectedAssetID: '',
            assetOptions: [],
            userOptions: [],

            // Asset Table
            assetData: {
                columns: [  
                    {
                        colTitle: 'Date Submitted',
                        sortBy: 'displayDateSubmit'
                    },
                    {
                        colTitle: 'Date Modified',
                        sortBy: 'displayDateModified'
                    },
                    {
                        colTitle: 'Asset Type',
                        sortBy: 'assetType'
                    },
                    {
                        colTitle: 'Asset Number',
                        sortBy: 'assetNumber'
                    },
                    {
                        colTitle: 'Asset Location',
                        sortBy: 'location'
                    },
                    {
                        colTitle: 'Item Name',
                        sortBy: 'itemName'
                    },
                    {
                        colTitle: 'Asset Description',
                        sortBy: 'itemDescription'
                    },
                    {
                        colTitle: 'Assigned To',
                        sortBy: 'assignedTo'
                    },
                    {
                        colTitle: 'Serial Number',
                        sortBy: 'serialNumber'
                    },
                    {
                        colTitle: 'Actions',
                        sortBy: ''
                    }
                ],
                rowData: [],
                filterWords: [
                    'displayDateSubmit',
                    'displayDateModified',
                    'assetType',
                    'assetNumber',
                    'location',
                    'itemName',
                    'itemDescription',
                    'assignedTo',
                    'serialNumber'
                ]
            }

        }
    },

    methods: {

        assetInfo: function(data) {
            this.selectedAssetID = data.id;
        },

        setAssetType: function(data) {
            this.assetType = data;
        },

        setAssignment: function(data) {
            this.assignedTo = data;
        },

        handleToggle: function(type) {
            if (type === 'CUI') {
                this.CUISort = this.CUISort ? false : true;
            } else if(type === 'IT') {
                this.itSort = this.itSort ? false : true;
            } else if (type === 'facility') {
                this.facilitySort = this.facilitySort ? false : true;
            } 
            this.populateAssetData();
        },

        deleteAsset: async function() {
            let token = this.$store.getters.getToken;

            if(this.reasonForRemoval == '') {
                this.requiredRemove = true;
                return;
            }
            this.reasonForRemoval = sanitizeInput(this.reasonForRemoval, this.$sanitize);
            let data = {
                data:{
                    reasonForRemoval: this.reasonForRemoval,
                    removed: true
                }
            };
                 
            try {
                await DatabaseLib.putRequest('strapiDatabase','asset-trackings',token,this.selectedAssetID, data);
            } catch(error) {
                this.p4 = true;
                return;
            }

            this.$refs.assetTable.closeDeleteModal();
            this.populateAssetData();

            window.scroll({top: 0, behavior: 'smooth'});
            this.p3 = true;
        },

        manageAsset: async function(data) {
            let token = this.$store.getters.getToken;

            try{
                let query = "filters[assetNumber][$eq][0]="+data.assetNumber;
                let response = await DatabaseLib.getRequest('strapiDatabase','asset-trackings',token,query);

                if(response.data.data.length > 0){
                    // asset already exists
                    this.editingAsset = true;
                    this.manageAssetID = response.data.data[0].id;
                    this.dateSubmit = response.data.data[0].attributes.dateSubmit;
                    this.dateModified = response.data.data[0].attributes.dateModified;
                    this.assetNumber = response.data.data[0].attributes.assetNumber;
                    this.assetLocation = response.data.data[0].attributes.location;
                    this.assetItem = response.data.data[0].attributes.itemName;
                    this.assetDescription = response.data.data[0].attributes.itemDescription;
                    this.assetSerialNumber = response.data.data[0].attributes.serialNumber;
                    this.assetType = response.data.data[0].attributes.assetType;
                    this.assignedTo = response.data.data[0].attributes.assigned_to;
                    this.reasonForRemoval = response.data.data[0].attributes.reasonForRemoval;
                    this.isRemoved = response.data.data[0].attributes.removed;

                    this.displayDateModified = formatDate(this.dateModified);
                    this.displayDateSubmit = formatDate(this.dateSubmit);
                    if(data.qrScan){this.p6 = true;}
                } else {
                    // asset does not exist
                    if(data.qrScan){this.p7 = true;}
                }
                this.getOptions();
                window.scroll({top: 0, behavior: 'smooth'});
            } catch(error) {
                this.p5 = true;
                console.log(error);
                window.scroll({top: 0, behavior: 'smooth'});
            }
        },

        clearAssetForm: function() {
            this.assetNumber = "";
            this.assetLocation = "";
            this.assetItem = "";
            this.assetDescription = "";
            this.assetSerialNumber = "";
            this.manageAssetID = "";
            this.assetType = "";
            this.assignedTo = "";
            this.reasonForRemoval = "";
            this.isRemoved = false;
            this.editingAsset = false;
            this.displayDateSubmit = formatDate(new Date().toISOString()),
            this.displayDateModified = formatDate(new Date().toISOString()),
            this.getOptions();
        },

        submitAsset: async function() {
            let token = this.$store.getters.getToken;
            
            this.assetNumber = sanitizeInput(this.assetNumber, this.$sanitize);
            this.assetLocation = sanitizeInput(this.assetLocation, this.$sanitize);
            this.assetItem = sanitizeInput(this.assetItem, this.$sanitize);   
            this.assetDescription = sanitizeInput(this.assetDescription, this.$sanitize);
            this.assetSerialNumber = sanitizeInput(this.assetSerialNumber, this.$sanitize);
            this.assignedTo = sanitizeInput(this.assignedTo, this.$sanitize);
            this.assetType = sanitizeInput(this.assetType, this.$sanitize);
            const utcTimestamp = new Date().toISOString();

            let data = {
                data:{
                    assetNumber: this.assetNumber,
                    dateSubmit: this.dateSubmit,
                    dateModified: utcTimestamp,
                    location: this.assetLocation,
                    itemName: this.assetItem,
                    itemDescription: this.assetDescription,
                    serialNumber: this.assetSerialNumber,
                    assetType: this.assetType,
                    assigned_to: this.assignedTo
                }
            }
            
            if(this.manageAssetID != '' && this.dateSubmit && this.editingAsset && this.assetNumber && this.assetLocation 
                && this.assetItem && this.assetDescription && this.assetSerialNumber && this.assetType && (this.assignedTo || this.assetType != "CUI")) {
                try {
                    await DatabaseLib.putRequest('strapiDatabase','asset-trackings',token,this.manageAssetID,data);

                    window.scroll({top: 0, behavior: 'smooth'});
                    this.p1 = true;
                    this.clearAssetForm(); // Housekeeping

                    // Resets Asset Table after submiting new asset
                    this.populateAssetData();
                    this.manageAssetID = '';
                } catch(error) {
                    console.error("Asset submit error:", error);
                    window.scroll({top: 0, behavior: 'smooth'});
                    this.p2 = true;
                    this.errorMsg = error.response?.data?.error?.message || "Asset was not submitted.";
                }
            } else if(!this.editingAsset && this.assetNumber && this.assetLocation && this.assetItem && this.assetDescription 
                && this.assetSerialNumber && this.assetType && (this.assignedTo || this.assetType != "CUI")) {
                try {
                    // check if asset number exists
                    let query = "filters[assetNumber][$eq][0]="+this.assetNumber;
                    let response = await DatabaseLib.getRequest('strapiDatabase','asset-trackings',token,query);

                    if(response.data.data.length > 0){
                        this.p2 = true;
                        this.errorMsg = "Asset number already exists";
                        return;
                    }

                    await DatabaseLib.postRequest('strapiDatabase','asset-trackings',token,data);

                    window.scroll({top: 0, behavior: 'smooth'});
                    this.p1 = true;
                    this.clearAssetForm(); // Housekeeping

                    // Resets Asset Table after submiting new Asset
                    this.populateAssetData();
                } catch(error) {
                    console.error("Asset submit error:", error);
                    window.scroll({top: 0, behavior: 'smooth'});
                    this.errorMsg = error.response?.data?.error?.message || "Asset was not submitted.";
                    this.p2 = true;
                }
            } else {
                window.scroll({top: 0, behavior: 'smooth'});
                console.error("Asset submit error: Missing fields");
                this.errorMsg = "Missing required fields";
                this.p2 = true;
            }
            this.editingAsset = false;
        },

        resetAssetTable: function() {
            this.assetData.rowData.splice(0);
        },

        enableCamera: async function() {
            this.QRCamera = true;
            const cameras = await Html5Qrcode.getCameras();

            const rearCamera = cameras.find(c =>
                c.label.toLowerCase().includes("back") ||
                c.label.toLowerCase().includes("rear")
            ) || cameras[0];

            this.scanner = new Html5Qrcode("qr-reader");

            await this.scanner.start(
                rearCamera.id,
                { fps: 15,
                    qrbox: { width: 150, height: 150 },
                    videoConstraints: {
                        facingMode: "environment",
                        width: { ideal: 1280 },
                        height: { ideal: 720 }
                    }
                 },       // fps and QR box size
                (decodedText) => {
                this.assetNumber = decodedText.trim();
                this.manageAsset({assetNumber: this.assetNumber, qrScan: true});
                this.stopScanner();          // stop after successful scan
                },
                (errorMessage) => {
                // optional: handle scanning errors per frame
                console.warn(errorMessage);
                }
            ).catch(err => console.error("Failed to start scanner:", err));

            const track = this.scanner.getRunningTrack();
            const capabilities = track.getCapabilities();

            if (capabilities.zoom) {
                track.applyConstraints({
                    advanced: [{ zoom: capabilities.zoom.max / 2 }]
                });
            }
            /*this.QRCamera = true;
            this.scanning = true;

            this.$nextTick(() => {
            if (this.$refs.QRCodeCamera) {
                this.$refs.QRCodeCamera.$el.scrollIntoView({
                    block: "center",
                    behavior: "smooth"
                });
            }
            });*/
          //this.$nextTick(() => this.$refs.QRCodeCamera.$el.scrollIntoView({ block: "center", behavior: "smooth"}))
        },

        /*onDecode: function(value) {
            if (!this.scanning) return;
            this.assetNumber = value.trim();
            this.scanning = false;
            this.QRCamera = false;
            window.scroll({top: 0, behavior: 'smooth'});
        },*/
        stopScanner() {
            if (this.scanner) {
                this.QRCamera = false;
                this.scanner.stop().then(() => {
                this.scanner.clear(); // remove video element
                }).catch(err => console.error(err));
            }
        },

        populateAssetData: async function() {
           /* let date = new Date();
            let year = date.getFullYear();
            let month = String(date.getMonth() + 1).padStart(2, '0');
            let day = String(date.getDate()).padStart(2, '0');
            this.dateSubmit = "" + year + "-" + month + "-" + day;
*/

            this.isSetUp = false;
            let token = this.$store.getters.getToken;
            let query = "filters[removed][$eq][0]=" + this.showRemoved;
            let response = '';
            
            try {
                this.resetAssetTable();
                response = await DatabaseLib.getRequest('strapiDatabase','asset-trackings',token,query);
                for(let i = 0; i < response.data.data.length; i = i + 1) {
                    let temp = response.data.data[i].attributes.assetType;
                    if((this.facilitySort && temp == "Facility Management") || (this.itSort && temp == "IT") || (this.CUISort && temp == "CUI")) {
                        this.assetData.rowData.push({
                            id: response.data.data[i].id,
                            dateSubmit: response.data.data[i].attributes.dateSubmit,
                            displayDateSubmit: formatDate(response.data.data[i].attributes.dateSubmit),
                            displayDateModified: formatDate(response.data.data[i].attributes.dateModified),
                            dateModified: response.data.data[i].attributes.dateModified,
                            assetNumber: response.data.data[i].attributes.assetNumber,
                            location: response.data.data[i].attributes.location,
                            itemName: response.data.data[i].attributes.itemName,
                            itemDescription: response.data.data[i].attributes.itemDescription,
                            serialNumber: response.data.data[i].attributes.serialNumber,
                            assetType: response.data.data[i].attributes.assetType,
                            assignedTo: response.data.data[i].attributes.assigned_to,
                            reasonForRemoval: response.data.data[i].attributes.reasonForRemoval,
                            removed: response.data.data[i].attributes.removed
                        }) 
                    }
                }
                this.isSetUp = true;
            } catch(error) {
                this.isSetUp = true;
                window.scroll({top: 0, behavior: 'smooth'});
                this.p5 = true;
                return;
            }
        },

        getOptions: async function(){
            this.assetOptions = [{text: "IT", value: "IT"}, {text: "Facility Management", value: "Facility Management"}, {text: "CUI", value: "CUI"}];
            const index = this.assetOptions.find(x => x.value === this.assetType);
            if(index){
                index.selected = true;
            }

            // get user options
            let holdVal = this.assignedTo;
            this.userOptions = [{text: "IT", value: "IT"},{text: "Facility Management", value: "Facility Management"}];

            let token = this.$store.getters.getToken;	
            let query = "filters[blocked][$eq][0]="+false+"&populate[1]=groups&populate[2]=role";
            let response = '';      
            try {
                response = await DatabaseLib.getRequest('strapiDatabase','users',token,query);
                let allUsers = [];
                for(let c = 0; c < response.data.length; c = c + 1){
                    if(response.data[c].role.name != "Administrator"){
                        allUsers.push(response.data[c]);
                    }
                }
                allUsers.forEach(user => {
                    this.userOptions.push({
                        text: user.firstName + ' ' + user.lastName,
                        value: user.username
                    });
                });
                const index2 = this.userOptions.find(x => x.value === holdVal);
                if(index2){
                    index2.selected = true;
                }
            } catch(error) {
                window.scroll({top: 0, behavior: 'smooth'});
                this.p19 = true;
                return;
            }
        },

    },
    watch: {
        showRemoved: function() {
            this.populateAssetData();
        }

    },   

    mounted() {
        this.populateAssetData();
        this.getOptions();
    }
}
</script>